export const existingPictures: Record<string, string> = {
  SCO: 'Актау',
  AKX: 'Актобе',
  ALA: 'Алматы',
  GUW: 'Атырау',
  BXH: 'Балхаш',
  DZN: 'Жезказган',
  SZI: 'Зайсан',
  KGF: 'Караганда',
  KOV: 'Кокшетау',
  KSN: 'Костанай',
  KZO: 'Кызылорда',
  NQZ: 'Астана',
  PPK: 'Петропавловск',
  PLX: 'Семей',
  TDK: 'Талдыкорган',
  DMB: 'Тараз',
  HSA: 'Туркестан',
  URA: 'Уральск',
  UZR: 'Урджар',
  UKK: 'Усть-Каменогорск',
  USJ: 'Ушарал',
  CIT: 'Шымкент',
  PWQ: 'Павлодар',
  AYK: 'Аркалык',
  ATX: 'Атбасар',
  EKB: 'Экибастуз',
  AUH: 'Абу-Даби',
  AMS: 'Амстердам',
  ANK: 'Анкара',
  AYT: 'Анталья',
  BAK: 'Баку',
  BKK: 'Бангкок',
  BER: 'Берлин',
  FRU: 'Бишкек',
  BSB: 'Бразилиа',
  BUD: 'Будапешт',
  WAW: 'Варшава',
  WLG: 'Веллингтон',
  VIE: 'Вена',
  DEL: 'Дели',
  DOH: 'Доха',
  DXB: 'Дубай',
  DYU: 'Душанбе',
  EVN: 'Ереван',
  JRS: 'Иерусалим',
  CAI: 'Каир',
  IEV: 'Киев',
  CPH: 'Копенгаген',
  KUL: 'Куала-Лумпур',
  KUT: 'Кутаиси',
  LIS: 'Лиссабон',
  LON: 'Лондон',
  MAD: 'Мадрид',
  MLE: 'Мале',
  MIL: 'Милан',
  MSQ: 'Минск',
  MOW: 'Москва',
  NYC: 'Нью-Йорк',
  PAR: 'Париж',
  BJS: 'Пекин',
  PRG: 'Прага',
  REK: 'Рейкьявик',
  RIX: 'Рига',
  ROM: 'Рим',
  SKD: 'Самарканд',
  LED: 'Санкт-Петербург',
  SEL: 'Сеул',
  SIN: 'Сингапур',
  SOF: 'София',
  IST: 'Стамбул',
  STO: 'Стокгольм',
  TAS: 'Ташкент',
  TBS: 'Тбилиси',
  TYO: 'Токио',
  FRA: 'Франкфурт-на-Майне',
};
